// The canonical host (2026-11-05, report-bulk-invite-429.md).
//
// Firebase Hosting always serves a project on <project>.web.app and
// <project>.firebaseapp.com as well as on its own domain, and those cannot be
// switched off. Loaded there, the app is a second origin: Auth0 does not list
// it as a callback URL (sign-in fails), and it keeps its own storage and its
// own service worker. So on those hosts the app does not boot: it replaces the
// location with the same path, query and hash on the project's own domain,
// VUE_APP_CANONICAL_ORIGIN (https://dev.rosterem.com.au for rosterem-dev,
// https://service.rosterem.com.au for rosterem-a0c99; set in deploy.yml).
//
// What it does NOT redirect:
//  - a preview channel (<project>--<channel>-<hash>.web.app): that is a real
//    deploy target, and sending it to the live domain would hide the preview;
//  - any other host (the own domain, localhost, an emulator);
//  - anything at all when VUE_APP_CANONICAL_ORIGIN is missing, blank or not an
//    https origin. A bad build value must never send everyone somewhere wrong.

const DEFAULT_HOST = /^[a-z0-9-]+\.(web\.app|firebaseapp\.com)$/i;

function canonicalOriginOf(value) {
  if (typeof value !== 'string' || value.trim() === '') return null;
  let url;
  try {
    url = new URL(value.trim());
  } catch {
    return null;
  }
  if (url.protocol !== 'https:') return null;
  if (url.pathname !== '/' || url.search || url.hash || url.username || url.password) return null;
  return url.origin;
}

// The URL to go to instead of `href`, or null to boot here.
export function canonicalRedirectTarget(href, canonicalOriginValue) {
  const origin = canonicalOriginOf(canonicalOriginValue);
  if (!origin) return null;
  let here;
  try {
    here = new URL(href);
  } catch {
    return null;
  }
  const host = here.hostname.toLowerCase();
  if (!DEFAULT_HOST.test(host)) return null;
  if (host.split('.')[0].includes('--')) return null; // a preview channel
  if (here.origin === origin) return null;
  return `${origin}${here.pathname}${here.search}${here.hash}`;
}
